import { Card, CardBody, Col, Modal } from "reactstrap";
import { H5, Image, LI, SVG, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { ProfileModalProp } from "../../../../../Type/UiKits";
import { PROFILE_DATA } from "../../../../../Data/UiKit/Modal";
import { BrooklynSimmons, Posts, PostCount, ProfileUserName } from "../../../../../Constant";

export const ProfileModal = ({ modalOne, modalOneTogggle }: ProfileModalProp) => {
  return (
    <Modal fade centered isOpen={modalOne} toggle={modalOneTogggle}>
      <div className="modal-dialog m-0">
        <div className="modal-content">
          <Col xl="12">
            <Card className="social-profile mb-0">
              <CardBody>
                <div className="social-img-wrap">
                  <div className="social-img">
                    <Image src={dynamicImage("avtar/profile.png")} alt="profile" />
                  </div>
                  <div className="edit-icon"><SVG iconId="profile-check" /></div>
                </div>
                <div className="social-details">
                  <H5 className="mb-1"><Link to={`${process.env.PUBLIC_URL}/social-app`}>{BrooklynSimmons}</Link></H5>
                  <span className="f-light">{ProfileUserName}</span>
                  <UL className="social-follow d-flex flex-row justify-content-center simple-list">
                    <LI>
                      <H5 className="mb-0">{PostCount}</H5>
                      <span className="f-light">{Posts}</span>
                    </LI>
                    {PROFILE_DATA.map(({ heading, data }, index) => (
                      <LI key={index}>
                        <H5 className="mb-0">{heading}</H5>
                        <span className="f-light">{data}</span>
                      </LI>
                    ))}
                  </UL>
                </div>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    </Modal>
  );
};
